import { ContactInfo } from './LeadParams';

export const dealerIds: { [key: string]: string } = {
  '245190': 'MjQ1MTkw',
  '278324': 'Mjc4MzI0',
  '278268': 'Mjc4MjY4',
  '339274': 'MzM5Mjc0',
  '452648': 'NDUyNjQ4',
  '60017': 'NjAwMTc=',
  '416141': 'NDE2MTQx',
  '371969': 'MzcxOTY5',
  '302519': 'MzAyNTE5',
};

// will use the page url once it's available
export const dealerPageUrl = 'https://www.autolist.com/someDealerPageTBD';

export function appendUrlToMessage(
  contactInfo: ContactInfo,
  remoteDealerId: string,
  vin: string
): ContactInfo {
  const newDealerId = dealerIds[remoteDealerId];

  if (newDealerId) {
    const url = `${dealerPageUrl}#vin=${vin}&id=${newDealerId}`;
    const messageText = `Lead requests information. Click this link: ${url}`;
    const message = contactInfo.message ? `${contactInfo.message} - ${messageText}` : messageText;

    const newContactInfo = {
      ...contactInfo,
      message,
    };

    console.log('o2o: new contact ', newContactInfo);

    return newContactInfo;
  }

  return contactInfo;
}
